
import 'regenerator-runtime/runtime';
import * as $ from 'jquery';

import * as AllyIntegrationUtil from 'src/integration/util';
import * as AllyConfig from 'src/shared/rest/Config';
import * as AllyFacade from 'src/shared/rest/facade';
import { LegacyWysiwygFeedbackController } from 'src/shared/wysiwyg/LegacyWysiwygFeedbackController';
import { TinyMceEditorListener } from 'src/shared/wysiwyg/tinymce/TinyMceEditorListener';

import * as CanvasUI from './ui/index';
import * as CanvasUiUtil from './ui/util';

const cssUrl = require('./canvas.css');

// Initialize i18n with the language of the page. This applies the language globally
const i18n = require('!!amdi18n-loader!src/integration/nls/integration');
const htmlLanguage = $('html').attr('lang').toLowerCase();
const lang = AllyIntegrationUtil.resolveLanguage(htmlLanguage);
i18n.init(lang);

AllyConfig.set({
    'lmsType': 'canvas',
    'baseUrl': window.ALLY_CFG.baseUrl,
    'clientId': window.ALLY_CFG.clientId,
    'courseId': CanvasUiUtil.getCourseId(),
    'lti13Id': window.ALLY_CFG.lti13Id
});

async function bootstrap() {
    // Allow the facade to configure the underlying transport mechanism
    AllyFacade.init();

    // Start scraping the canvas UI looking for files to augment
    await CanvasUI.init();

    // Load CSS files
    AllyIntegrationUtil.loadCSS(`${AllyConfig.baseUrl() }/${ cssUrl}`);

    const { flags = {} } = await AllyFacade.getClientInfo();
    if (flags.ifLaunchFromWysiwyg && !(window.ENV || {}).current_user_is_student) {
        // Initialize Wysiwyg feedback functionality
        const tinyMceEditorListener = new TinyMceEditorListener(
            AllyConfig.baseUrl(),
            i18n,
            window,
            !flags.nativeWysiwygAxEnabled
        );

        const wysiwygFeedbackController = new LegacyWysiwygFeedbackController(
            AllyConfig.baseUrl(),
            CanvasUiUtil.getCourseId(),
            lang,
            i18n,
            tinyMceEditorListener
        );
        wysiwygFeedbackController.start();
    }
}

bootstrap().catch((e) => {
    console.error('Failed to bootstrap ally', e);
});
